export default {
    kh: 'เขมร',
    en: 'ภาษาอังกฤษ',
    lao:"าว",
    thai:"ไทย"
};
